import { Component, ElementRef, OnInit, ViewChildren } from '@angular/core';
import { FormBuilder, FormControl, FormControlName, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { fromEvent, merge, Observable, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ServiceCategory } from 'src/app/db/models/categories';
import { Country, ProService } from 'src/app/db/models/pro-services';
import { GenericValidator } from 'src/app/directives/generic-validator';
import { CategoryService } from 'src/app/services/category.service';
import { ProfessionalServiceService } from 'src/app/services/professional-service.service';
import { StatesCitiesService } from 'src/app/services/states-cities.service';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-service-providers-edit',
  templateUrl: './service-providers-edit.component.html',
  styleUrls: ['./service-providers-edit.component.scss']
})
export class ServiceProvidersEditComponent implements OnInit {

  @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[];

  title = 'Service Information';

  sform: FormGroup;

  pro_service = new ProService();
  private sub: Subscription;

  categories: ServiceCategory[];
  countries: Country[];
  states: string[];
  cities: string[];

  displayMessage: { [key: string]: string } = {};
  private validationMessages: { [key: string]: { [key: string]: string } };
  private genericValidator: GenericValidator;

  constructor(private fb: FormBuilder,
        private router: Router,
        private service: ProfessionalServiceService,
        private cservice: CategoryService,
        private sservice: StatesCitiesService)
        {
          this.validationMessages = {
            name: {
              required: 'Service name is required'
          },
          description: {
            required: 'Please describe your service'
          },
          serviceCategoryId:  {
            required: 'Select at least one category'
          },
          contactNumber: {
            required: 'A working mobile contact is required'
          },
          line: {
            required: 'A valid address is required'
          },
          country:{
            required: 'Please select your country of service'
          },
           state:{
            required: 'Please select your state of service'
          },
          city:{
            required: 'Please select your city of service'
          }
        }

          this.genericValidator = new GenericValidator(this.validationMessages);
        }

  ngOnInit() {
    this.createDataForm();
    this.getCategories();

    this.countries = this.sservice.getCountries();
    this.country.valueChanges.subscribe((country) => {
      this.state.reset();
      this.state.disable();
      if (country) {
        this.states = this.sservice.getStatesByCountry(country);
        this.state.enable();
      }
    });

    this.state.valueChanges.subscribe((state) => {
      this.city.reset();
      this.city.disable();
      if (state) {
        this.cities = this.sservice.getCitiesByState(this.country.value, state);
        this.city.enable();
      }
    })
  }

  createDataForm(){
    this.sform = this.fb.group({
      name: [null, Validators.required],
      description: [null, Validators.required],
      serviceCategoryId: [null, Validators.required],
      contactNumber: [null, Validators.required],
      line: [null],
      country: [null, Validators.required],
      state: [null, Validators.required],
      city: [null, Validators.required],
    })
  }

  ngAfterViewInit(): void {
    const controlBlurs: Observable<any>[] = this.formInputElements
      .map((formControl: ElementRef) => fromEvent(formControl.nativeElement, 'blur'));
    merge(this.sform.valueChanges, ...controlBlurs).pipe(
      debounceTime(800)
    ).subscribe(value => {
      this.displayMessage = this.genericValidator.processMessages(this.sform);
    });
  }

  getCategories(){
    this.cservice.getAllServiceCategories().subscribe(
      data => {
        this.categories = data;
      }
    )
  }

  get name(){
    return this.sform.controls.name as FormControl;
  }

  get description(){
    return this.sform.controls.description as FormControl;
  }

  get serviceCategoryId(){
    return this.sform.controls.serviceCategoryId as FormControl;
  }

  get contactNumber(){
    return this.sform.controls.contactNumber as FormControl;
  }

  get line(){
    return this.sform.controls.line as FormControl;
  }

  get city() {
    return this.sform.controls.city as FormControl;
  }

  get state() {
    return this.sform.controls.state as FormControl;
  }

  get country() {
    return this.sform.controls.country as FormControl;
  }

  mapEntity(): void {
    this.pro_service.name = this.name.value;
    this.pro_service.description = this.description.value;
    this.pro_service.serviceCategoryId = this.serviceCategoryId.value;
    this.pro_service.primaryContactNumber = this.contactNumber.value;
    this.pro_service.addressLine  = this.line.value;
    this.pro_service.city = this.city.value;
    this.pro_service.state = this.state.value,
    this.pro_service.country = this.country.value;
  }

  saveData(){
    if(this.sform.valid){
      this.mapEntity();
      console.log('New Service', this.pro_service);
      if (this.pro_service.id == null) {
        this.service.createProfessionalService(this.pro_service)
        .subscribe({
          next: () => {
            this.successNotification();

          },
          error: err => {
            this.errorNotification();

          }
        })
      }
    }
  }

  successNotification(){
    Swal.fire({
      icon: 'success',
      title: 'Awesome',
      text:'Your Service will now appear in searches',
      showDenyButton: false,
      focusConfirm: true,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Ok',
    }).then((result) => {
      if(result.isConfirmed){
        this.abort();
      }
    })
  }

  errorNotification(){
    Swal.fire({
      icon: 'error',
      title: 'Oops',
      text: 'Service with the same name already exist!',
      showDenyButton: true,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-repeat"></i> Try Again!',
      denyButtonText: `<i class="fa fa-power-off"></i> Cancel`,
    }).then((result) => {
      if (result.isConfirmed) {
        this.reload();
      } else {
        this.abort();
      }
    })
  }

  abort(){
     this.router.navigate(['/']);
    }

  reload(){
     this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
       this.router.navigate(['service_provider_edit']);
     })
    }


}
